import { render, staticRenderFns } from "./feature-move-dialog.vue?vue&type=template&id=3479d7aa"
import script from "./feature-move-dialog.vue?vue&type=script&lang=js"
export * from "./feature-move-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3053040914/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3479d7aa')) {
      api.createRecord('3479d7aa', component.options)
    } else {
      api.reload('3479d7aa', component.options)
    }
    module.hot.accept("./feature-move-dialog.vue?vue&type=template&id=3479d7aa", function () {
      api.rerender('3479d7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/features/feature-move-dialog.vue"
export default component.exports